import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Button,
  Dropdown,
  InputGroup,
  Form,
  Table,
} from "react-bootstrap";
import {
  FaPlus,
  FaCog,
  FaFilter,
  FaRedo,
  FaSearch,
  FaSort,
  FaToggleOff,
  FaToggleOn,
  FaEdit,
  FaTrashAlt,
} from "react-icons/fa";
import { getOrganizationLevelList } from "../../services/OrganisationServices/organizationLevelMangeService";
import { getMethods } from "../../services/utilityFunctions";
 

const OrganizationLevelTable = () => {
  const navigate = useNavigate();
  const [pagedata, setPagedata] = useState({
    pageNum: 1,
    pageSize: 12,
    offset: 0,
    totalCount: 0,
  });
  const [tableData, setTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState({ status: false, message: "" });
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [allData, setAllData] = useState([]);

  const columnNames = {
    id: "Organization Level ID",
    createdBy: "Created By ID",
    modifiedBy: "Modified By ID",
    createdByName: "Created By Name",
    modifiedByName: "Modified By Name",
    createdDatetime: "Created Date and Time",
    modifiedDatetime: "Modified Date and Time",
    name: "Organization Level Name",
    description: "Description",
    managerId: "Manager ID",
    managerName: "Manager Name",
    regionId: "Region ID",
    regionName: "Region Name",
    status: "Status",
  };

  const defaultColumns = [
    "name",
    "description",
    "managerName",
    "regionName",
    "status",
  ];

  const [tableColumns, setTableColumns] = useState(defaultColumns);
  const [methods, setMethods] = useState({
    POST: 0,
    GET: 0,
    PUT: 0,
    DELETE: 0,
    PATCH: 0,
  });

  const getOrgLevelData = async (pageNum = 1) => {
    setLoading(true);
    try {
      if (allData.length >= pageNum) {
        setTableData(allData[pageNum - 1]);
        setCurrentPage(pageNum);
        setLoading(false);
        return;
      }

      const [res, method] = await Promise.all([
        getOrganizationLevelList(pageNum),
        getMethods("Organization", "Organization Levels"),
      ]);

      if (res.status === "fail") {
        throw new Error(res.message);
      }

      setMethods(method);
      setPagedata({
        ...res.data,
        entityList: undefined,
      });
      setTableData(res.data.entityList);
      setAllData([...allData, res.data.entityList]);
      setCurrentPage(res.data.pageNum);
    } catch (err) {
      setError({
        status: true,
        message: err.message || "Failed to fetch data",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOrgLevelData();
  }, []);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (value === "") {
      getOrgLevelData(currentPage);
    } else {
      const searchResults = search(value, allData.flat());
      setTableData(searchResults);
    }
  };

  function search(query, data) {
    const lowerQuery = query.toLowerCase();
    return data.filter((item) => {
      return Object.entries(item).some(([key, value]) => {
        if (typeof value === "object" && value !== null) {
          return Object.values(value).some((val) =>
            String(val).toLowerCase().includes(lowerQuery)
          );
        }
        return String(value).toLowerCase().includes(lowerQuery);
      });
    });
  }

  const startIndex = () => {
    return (currentPage - 1) * pagedata.pageSize;
  };

  const handleSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    const sortedData = [...tableData].sort((a, b) => {
      const aValue = String(a[key]).toLowerCase();
      const bValue = String(b[key]).toLowerCase();

      if (direction === "ascending") {
        return aValue.localeCompare(bValue);
      }
      return bValue.localeCompare(aValue);
    });

    setSortConfig({ key, direction });
    setTableData(sortedData);
  };

  //   const handleDelete = async (id) => {
  //     if (!window.confirm("Are you sure you want to delete this organization level?")) {
  //       return;
  //     }

  //     setDeleteLoading(true);
  //     try {
  //       const res = await deleteOrganizationLevel(id);
  //       const myButton = document.getElementById("myToastButton");

  //       if (res.status === "success") {
  //         callToast("success", "Success", "Organization level deleted successfully", myButton);
  //         setTableData(tableData.filter((item) => item.id !== id));
  //         // Refresh data if we're on the last item of the page
  //         if (tableData.length === 1 && currentPage > 1) {
  //           getOrgLevelData(currentPage - 1);
  //         }
  //       } else {
  //         throw new Error(res.message);
  //       }
  //     } catch (err) {
  //       const myButton = document.getElementById("myToastButton");
  //       callToast("error", "Error", err.message || "Failed to delete organization level", myButton);
  //     } finally {
  //       setDeleteLoading(false);
  //     }
  //   };

  const handleToggleStatus = async (index) => {
    const newData = [...tableData];
    const item = newData[index];
    const newStatus = item.status === "Y" ? "N" : "Y";

    try {
      // Assuming there's an API call to update status
      // const res = await updateOrganizationLevelStatus(item.id, newStatus);
      newData[index].status = newStatus;
      setTableData(newData);

      const myButton = document.getElementById("myToastButton");
    //   callToast("success", "Success", "Status updated successfully", myButton);
    } catch (err) {
      const myButton = document.getElementById("myToastButton");
    //   callToast("error", "Error", "Failed to update status", myButton);
    }
  };

  return (
    <>
      <Row>
        <div
          id="myToastButton"
          className="pixel-corners"
          style={{ display: "block" }}
        ></div>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-1">Organization Levels</h4>
                {methods.POST == 0 ? null : (
                  <Button
                    variant="primary"
                    className="d-flex align-items-center"
                    onClick={() => navigate("/organization-levels/add")}
                  >
                    <FaPlus className="me-2" /> Add Organization Level
                  </Button>
                )}
              </div>
              <div className="d-flex align-items-center">
                <Dropdown autoClose="outside">
                  <Dropdown.Toggle variant="light" className="me-2">
                    <FaCog className="text-secondary" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <div onClick={(e) => e.stopPropagation()}>
                      <div className="px-3 py-2">
                        <div className="form-check">
                          <label
                            className="form-check-label ms-2"
                            htmlFor="selectAll"
                          >
                            Select All
                          </label>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="selectAll"
                            onChange={(e) => {
                              setTableColumns(
                                e.target.checked
                                  ? Object.keys(columnNames)
                                  : defaultColumns
                              );
                            }}
                            checked={
                              tableColumns.length ===
                              Object.keys(columnNames).length
                            }
                          />
                          <hr />
                        </div>
                      </div>
                    </div>
                    {tableData.length > 0 &&
                      Object.keys(columnNames).map((key) => (
                        <div key={key} onClick={(e) => e.stopPropagation()}>
                          <div className="px-3 py-2">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id={`column-${key}`}
                                checked={tableColumns.includes(key)}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setTableColumns([...tableColumns, key]);
                                  } else {
                                    setTableColumns(
                                      tableColumns.filter((col) => col !== key)
                                    );
                                  }
                                }}
                              />
                              <label
                                className="form-check-label ms-2"
                                htmlFor={`column-${key}`}
                              >
                                {columnNames[key]}
                              </label>
                            </div>
                          </div>
                        </div>
                      ))}
                  </Dropdown.Menu>
                </Dropdown>
                <Button variant="light" className="me-2">
                  <FaFilter />
                </Button>
                <Button
                  variant="light"
                  className="me-2"
                  onClick={() => getOrgLevelData(currentPage)}
                >
                  <FaRedo />
                </Button>
                <InputGroup style={{ width: "300px" }}>
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={handleSearch}
                    className="rounded"
                  />
                </InputGroup>
              </div>
            </Card.Header>
            <Card.Body>
              {loading ? (
                <center>
                  <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </center>
              ) : error.status ? (
                <center>
                  <h3>{error.message}</h3>
                </center>
              ) : (
                <div
                  className="table-responsive border border-secondary rounded"
                  style={{ padding: "1rem" }}
                >
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        {tableColumns.map((item) => (
                          <th
                            key={item}
                            onClick={() => handleSort(item)}
                            style={{ cursor: "pointer" }}
                          >
                            {columnNames[item]} <FaSort />
                          </th>
                        ))}
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((item, index) => (
                        <tr key={item.id}>
                          {tableColumns.map((column) => (
                            <td key={`${item.id}-${column}`}>
                              {column === "status" ? (
                                <span
                                  className={`badge ${
                                    item[column] === "Y"
                                      ? "bg-success"
                                      : "bg-danger"
                                  }`}
                                >
                                  {item[column]}
                                </span>
                              ) : (
                                item[column]
                              )}
                            </td>
                          ))}
                          <td>
                            <Dropdown autoClose="outside">
                              <Dropdown.Toggle
                                variant="light"
                                size="sm"
                                className="border-0"
                              >
                                Actions
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {methods.PATCH == 0 ? null : (
                                  <Dropdown.Item
                                    onClick={() => handleToggleStatus(index)}
                                    className="d-flex align-items-center"
                                  >
                                    {item.status === "Y" ? (
                                      <FaToggleOff className="me-2 text-warning" />
                                    ) : (
                                      <FaToggleOn className="me-2 text-success" />
                                    )}
                                    Toggle Status
                                  </Dropdown.Item>
                                )}
                                {methods.PUT == 0 ? null : (
                                  <Dropdown.Item
                                    onClick={() =>
                                      navigate("/organization-levels/update", {
                                        state: { organizationLevelData: item },
                                      })
                                    }
                                    className="d-flex align-items-center"
                                  >
                                    <FaEdit className="me-2 text-info" /> Edit
                                  </Dropdown.Item>
                                )}
                                {methods.DELETE == 0 ? null : (
                                  <Dropdown.Item
                                    // onClick={() => handleDelete(item.id)}
                                    onClick={() =>
                                      console.log("Delete clicked")
                                    }
                                    className="d-flex align-items-center"
                                  >
                                    {deleteLoading ? (
                                      <div className="spinner-border spinner-border-sm text-danger me-2" />
                                    ) : (
                                      <FaTrashAlt className="me-2 text-danger" />
                                    )}
                                    Delete
                                  </Dropdown.Item>
                                )}
                              </Dropdown.Menu>
                            </Dropdown>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {!tableData.length && (
                    <p className="text-center my-3">No results found.</p>
                  )}
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>
                      Showing {tableData.length ? startIndex() + 1 : 0} to{" "}
                      {Math.min(
                        startIndex() + pagedata.pageSize,
                        pagedata.totalCount
                      )}{" "}
                      of {pagedata.totalCount} entries
                    </div>
                    <div>
                      {Array.from({
                        length: Math.ceil(
                          pagedata.totalCount / pagedata.pageSize
                        ),
                      }).map((_, index) => (
                        <Button
                          key={index}
                          variant="light"
                          className={`me-1 ${
                            currentPage === index + 1 ? "active" : ""
                          }`}
                          onClick={() => getOrgLevelData(index + 1)}
                          disabled={loading}
                        >
                          {index + 1}
                        </Button>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default OrganizationLevelTable;
